<template>
    <div class="rec-job-overview">
        <div class="overview-header flex-center">
            <div class="header-info">
                <div class="header-info_top flex-center">
                    <div class="info-name ellipsis-single">{{ job.position_info.name }}</div>
                    <div class="info-salary">{{ job.position_info.salary }}</div>
                </div>

                <div class="header-info_bottom flex-center">
                    <div class="info-address other-info">
                        <i class="el-icon-location"></i>
                        <span>{{ job.position_info.city }}</span>
                    </div>

                    <div class="info-experience other-info">
                        <i class="el-icon-s-cooperation"></i>
                        <span>{{ job.position_info.experience_type }} </span>
                    </div>

                    <div class="info-degree other-info">
                        <i class="el-icon-s-management"></i>
                        <span>{{ job.position_info.degree }}</span>
                    </div>
                </div>
            </div>

            <el-button type="primary" :disabled="job.apply_status === 1" @click="handleApply">
                {{ job.apply_status === 0 ? "立即投递" : "已投递" }}
            </el-button>
        </div>

        <div class="overview-desc">
            <span class="overview-title">职位描述：</span>

            <div class="desc-content">
                <div class="desc-item" v-for="(item, index) in job.position_info.position_introduction?.split('\n') || []" :key="index">
                    {{ item }}
                </div>
            </div>
        </div>

        <div class="overview-address">
            <span class="overview-title">工作地址：</span>

            <div class="address-text">
                <i class="el-icon-location"></i>
                <span>{{ work_address }}</span>
            </div>

            <div class="address-map" @click="mapVisible = true">
                <MapBox :location="job.position_info.address.location"></MapBox>

                <div class="view-more flex-center">
                    <img src="@/assets/map-icon.png" alt="" />
                    <span>点击查看地图</span>
                </div>
            </div>
        </div>

        <div class="overview-more">
            <el-button class="border-primary" plain @click="$emit('more')">查看更多信息</el-button>
        </div>

        <MapOverview v-model="mapVisible" :location="job.position_info.address.location"></MapOverview>
    </div>
</template>

<script>
import MapBox from "./MapBox.vue";
import MapOverview from "./MapOverview.vue";

export default {
    data() {
        return {
            mapVisible: false,
        };
    },

    props: {
        job: {
            type: Object,
            required: true,
        },
    },

    components: {
        MapBox,
        MapOverview,
    },

    computed: {
        work_address() {
            const { province, city, district, address } = this.job.position_info.address;

            return `${province}${city}${district}${address}`;
        },
    },

    methods: {
        handleApply() {
            this.$emit("apply");
        },
    },
};
</script>

<style lang="scss" scoped>
.rec-job-overview {
    .el-button {
        --primary-color: #685ef5;
        --disabled-primary-color: rgba(104, 94, 245, 0.5);
        border-radius: 8px;

        &.el-button--primary {
            background-color: var(--primary-color);
            border-color: var(--primary-color);

            &.is-disabled {
                background-color: var(--disabled-primary-color);
                border-color: transparent;
            }
        }

        &.border-primary {
            border-color: var(--primary-color);
            color: var(--primary-color);
        }
    }

    .overview-header {
        justify-content: space-between;
        gap: 16px;

        .header-info {
            flex: 1;
            min-width: 0;

            &_top {
                justify-content: flex-start;
                gap: 20px;
                margin-bottom: 12px;

                .info-name {
                    font-weight: bold;
                    font-size: 20px;
                    color: #222222;
                }

                .info-salary {
                    font-weight: bold;
                    font-size: 20px;
                    color: #ffa53d;
                    flex-shrink: 0;
                }
            }

            &_bottom {
                justify-content: flex-start;
                gap: 20px;

                .other-info {
                    display: flex;
                    align-content: center;

                    i {
                        font-size: 16px;
                        line-height: 20px;
                        color: #d6d6d6;
                    }

                    span {
                        line-height: 20px;
                        color: #222223;
                    }
                }
            }
        }
    }

    .overview-title {
        display: inline-block;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #222222;
        margin-bottom: 6px;
    }

    .overview-desc {
        margin-top: 30px;

        .desc-content {
            font-weight: 400;
            font-size: 14px;
            color: #222222;
            line-height: 24px;
        }
    }

    .overview-address {
        margin-top: 30px;

        .address-text {
            display: flex;
            align-content: center;

            i {
                font-size: 16px;
                line-height: 20px;
                color: #d6d6d6;
            }

            span {
                line-height: 20px;
                color: #222223;
            }
        }

        .address-map {
            margin-top: 8px;
            height: 150px;
            border-radius: 8px;
            overflow: hidden;
            position: relative;

            .view-more {
                position: absolute;
                right: 12px;
                bottom: 12px;
                background-color: #ffffff;
                border-radius: 8px;
                gap: 4px;
                padding: 4px 12px;
                cursor: pointer;

                img {
                    width: 24px;
                    height: 24px;
                    object-fit: cover;
                }

                span {
                    font-size: 12px;
                }

                &:hover {
                    span {
                        color: #685ef5;
                    }
                }
            }
        }
    }

    .overview-more {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
}
</style>
